var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaryActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1465 2.84863H5.14648C4.88127 2.84863 4.62691 2.95399 4.43938 3.14153C4.25184 3.32906 4.14648 3.58342 4.14648 3.84863V19.8486C4.14648 20.1138 4.25184 20.3682 4.43938 20.5557C4.62691 20.7433 4.88127 20.8486 5.14648 20.8486H6.14648V21.8486C6.14648 22.1138 6.25184 22.3682 6.43938 22.5557C6.62691 22.7433 6.88127 22.8486 7.14648 22.8486C7.4117 22.8486 7.66605 22.7433 7.85359 22.5557C8.04113 22.3682 8.14648 22.1138 8.14648 21.8486V20.8486H17.1465C17.9421 20.8486 18.7052 20.5326 19.2678 19.97C19.8304 19.4073 20.1465 18.6443 20.1465 17.8486V5.84863C20.1465 5.05298 19.8304 4.28992 19.2678 3.72731C18.7052 3.1647 17.9421 2.84863 17.1465 2.84863ZM14.1465 18.8486H6.14648V4.84863H14.1465V18.8486ZM18.1465 17.8486C18.1465 18.1138 18.0411 18.3682 17.8536 18.5557C17.6661 18.7433 17.4117 18.8486 17.1465 18.8486H16.1465V4.84863H17.1465C17.4117 4.84863 17.6661 4.95399 17.8536 5.14153C18.0411 5.32906 18.1465 5.58342 18.1465 5.84863V17.8486Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryActive);
export default __webpack_public_path__ + "static/media/DiaryActive.fb5409e37b2d5f86e1e5907485302ce2.svg";
export { ForwardRef as ReactComponent };